var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 44,
    viewBox: "0 0 52 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 0C2.89062 0 3.75 0.859375 3.75 1.875V12.5H46.25V1.875C46.25 0.859375 47.0312 0 48.125 0C49.1406 0 50 0.859375 50 1.875V14.375V34.375V38.125C50 39.2188 49.1406 40 48.125 40C47.0312 40 46.25 39.2188 46.25 38.125V36.25H3.75V38.125C3.75 39.2188 2.89062 40 1.875 40C0.78125 40 0 39.2188 0 38.125V34.375V14.375V1.875C0 0.859375 0.78125 0 1.875 0ZM3.75 32.5H46.25V16.25H3.75V32.5ZM27.5 2.5C27.5 1.17188 28.5938 0 30 0H35C36.3281 0 37.5 1.17188 37.5 2.5V7.5C37.5 8.90625 36.3281 10 35 10H30C28.5938 10 27.5 8.90625 27.5 7.5V2.5ZM10 20H15C16.3281 20 17.5 21.1719 17.5 22.5V27.5C17.5 28.9062 16.3281 30 15 30H10C8.59375 30 7.5 28.9062 7.5 27.5V22.5C7.5 21.1719 8.59375 20 10 20ZM22.5 20H27.5C28.8281 20 30 21.1719 30 22.5V27.5C30 28.9062 28.8281 30 27.5 30H22.5C21.0938 30 20 28.9062 20 27.5V22.5C20 21.1719 21.0938 20 22.5 20ZM87.28",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStation);
export default __webpack_public_path__ + "static/media/icon-station.c6c23a7265f65526bb9a2bf7ac49e181.svg";
export { ForwardRef as ReactComponent };